import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Card, Grid, Table, Icon, Label } from 'semantic-ui-react';

import { YoutubeIcon, FacebookIcon, InstagramIcon, TwitterIcon, PinterestIcon, BlogIcon } from '../dyzio-icons';

const PLATFORMS = {
  blog: 'blog',
  youtube: 'youtube',
  twitter: 'twitter',
  instagram: 'instagram',
  facebook: 'facebook',
  pinterest: 'pinterest',
};

const getRates = (details, platform) => {
  const rates = [];
  if (!details) return null;

  const range = _.range(1, 12);
  _.forEach(range, v => {
    const key = `${platform}Rate${v}`;
    const value = details[key];
    if (value) {
      rates.push(value);
    }
  });
  return rates;
};

const Rates = props => {
  const { items, icon } = props;
  return (
    <Table.Row>
      <Table.Cell width={3} textAlign="center">
        {icon}
      </Table.Cell>
      <Table.Cell width={13}>
        { _.map(items, item => <Label basic color="pink" size="large" horizontal>{ item }</Label>) }
      </Table.Cell>
    </Table.Row>
  );
};

const BlogosphereRateCard = props => {
  const { details } = props;
  const twitterRates = getRates(details, PLATFORMS.twitter);
  const facebookRates = getRates(details, PLATFORMS.facebook);
  const instagramRates = getRates(details, PLATFORMS.instagram);
  const youtubeRates = getRates(details, PLATFORMS.youtube);
  const blogRates = getRates(details, PLATFORMS.blog);
  const pinterestRates = getRates(details, PLATFORMS.pinterest);
  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>
          Rate Card (fee per post)
        </Card.Header>
      </Card.Content>
      <Card.Content style={{ margin: 0, padding: 0 }}>
        <Table basic="very">
          <Table.Body>
            { youtubeRates && <Rates items={youtubeRates} icon={<YoutubeIcon size="big" />} />}

            { instagramRates && <Rates items={instagramRates} icon={<InstagramIcon size="big" />} />}

            { facebookRates && <Rates items={facebookRates} icon={<FacebookIcon size="big" />} /> }

            { twitterRates && <Rates items={twitterRates} icon={<TwitterIcon size="big" />} /> }

            { pinterestRates && <Rates items={pinterestRates} icon={<PinterestIcon size="big" />} /> }

            { blogRates && <Rates items={blogRates} icon={<BlogIcon size="big" />} /> }
          </Table.Body>
        </Table>
      </Card.Content>
    </Card>
  );
};

BlogosphereRateCard.propTypes = {
  details: PropTypes.object.isRequired,
};

export default BlogosphereRateCard;



/** WEBPACK FOOTER **
 ** ./src/components/blogosphere-rate-card/index.js
 **/